// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"259":"2631fd39","691":"db7ff42c"}[chunkId] + ".css";
};